import axios from 'axios'
import router from '../router'
import {getStorageToken} from "@/mixins/Auth.js"
import {logout} from "../mixins/Auth";
import {apiURL} from "./config";


const onUnauthorized = () => {
   router.push({path: "/auth"});
};

export const setAuthInHeader = token => {
  axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
};

export const request = {
  get(path, data=null) {
    return axios.get(`${apiURL + path}`, {params: data})
      .catch(({response}) => {
        const {status} = response;
        if (status === 400 || status === 401 || status === 500){
          return onUnauthorized();
        }else if(status === Errored) {
          alert("잘못된 정보입니다.")
        }
        throw Error(response)
      })
  },
  post(path, data) {
    return axios.post(`${apiURL + path}`, data)
      .catch(({response}) => {
        const {status} = response;
        if (status === 400 || status === 401 || satus === 500){
          return onUnauthorized();
        }else if(status === Errored){
          alert("잘못된 정보입니다.")
        }
        throw Error(response)
      })
  }
};

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    if(!axios.defaults.headers.common['Authorization']){
        let token = getStorageToken();
        if(token){
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    }else{
        return config;
    }


}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
